/**
 * Uppercase a display value (e.g. customer name on PDFs).
 * e.g. "hardikbhai hareshbhai" -> "HARDIKBHAI HARESHBHAI"
 */
export function capitalizeWords(value) {
  const str = String(value ?? "").trim();
  if (!str) return "";
  if (str === "-" || str.toLowerCase() === "n/a") return str;
  return str.toUpperCase();
}
